//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import RatingsList from "~/components/structure/RatingsList"
import RankingList from "~/components/ranking/RankingList.vue";

export default {
	name: "organisations-slug-factions",
	components: {
		RankingList,
	},
	props: {
		slug: {
			type: String,
			required: true,
		},
		organisation: {
			type: Object,
			required: true,
		},
		ranking: {
			type: Object,
			required: true,
		},
	},
	computed: {
		rankingList() {
			return this.$store.state.orderByDesc.ranking
				? this.ranking.ranking.factions
				: [...this.ranking.ranking.factions].reverse();
		},
	},
	methods: {
		getTitle(faction) {
			return this.$store.getters.getFactionName(faction.id);
		},
		getTags(e) {
			return this.$store.state.filters.ranking.filters.canton;
		},
		descString(faction) {
			return this.$store.getters["rankings/getRankingDescFaction"](faction, this.organisation, this.$i18n.locale);
		},
		getImgUrl(e) {
			return `/ngo-logo-placeholder.png`;
		},
		getTo(faction) {
			const path = this.localePath({
				name: "organisations-slug",
			});
			return faction.id ? `${path}?faction=${faction.id}` : ``;
		},
	},
	nuxtI18n: {
		paths: {
			en: "/organisations/:slug/factions",
			de: "/organisationen/:slug/fraktionen",
			fr: "/organisations/:slug/fractions",
			it: "/organizzazioni/:slug/frazioni",
		},
	},
	head() {
		return {
			title: `${this.$t(`factions`)} – ${this.organisation.name} – VoteLog`,
		};
	},
};
